import React, { useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import SectionSubHeader from "../sectionSubHeader";
import SectionHeader from "../sectionHeader";
import CustomButton from "../CustomButton";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";

const OpenPosition = () => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (iframeRef.current) {
      const doc = iframeRef.current.contentWindow.document;
      doc.open();
      doc.write(`
        <html>
          <head>
            <script type="text/javascript" 
            src="https://jobsapi.ceipal.com/APISource/widget.js" 
            data-ceipal-api-key="UzU4SzVTQXlqUkJhN2RmZTZLR3FEZz09" 
            data-ceipal-career-portal-id="Z3RkUkt2OXZJVld2MjFpOVRSTXoxZz09">
            </script>
          </head>
          <body>
            <div id="example-widget-container"></div>
          </body>
        </html>
      `);
      doc.close();
    }
  }, []);

  return (
    <div className="section-bg open-position" id="open-position">
      <Container className="">
        <SectionHeader mainText1="OPEN POSITIONS" />
        <Row className="mb-50">
          <Col lg={8}>
            <SectionSubHeader headerText="Current Job Openings" />
          </Col>
          <Col lg={4}>
            <p>
              Exciting career growth, innovation, & impact. Explore
              opportunities today!
            </p>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <iframe
              ref={iframeRef}
              title="CEIPAL Job Widget"
              style={{ width: "100%", height: "800px", border: "none" }}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default OpenPosition;
